import React, { useState } from 'react';
import './FreeAttractionCard.css';

const FreeAttractionCard = ({ imageSrc, title, subtitle, badgeText, discountText, description }) => {
  const [liked, setLiked] = useState(false);
  const [hovered, setHovered] = useState(false);

  const toggleLike = () => {
    setLiked(!liked);
  };

  return (
    <div 
      className="free-card" 
      onMouseEnter={() => setHovered(true)} 
      onMouseLeave={() => setHovered(false)}
    >
      <img src={imageSrc} alt={title} className="free-card-image" />
      {badgeText && <div className="free-badge">{badgeText}</div>}
      {discountText && <div className="free-discount">{discountText}</div>}
      <div className={`free-card-overlay ${hovered ? 'hovered' : ''}`}>
        <div className="free-card-title">{title}</div>
        {hovered && <div className="free-card-description">{subtitle}</div>}
      </div>
    </div>
  );
};

export default FreeAttractionCard;
